var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emd-breadcrumb" }, [
    _c(
      "ol",
      _vm._l(_vm.routes, function (route, index) {
        return _c(
          "li",
          {
            key: "route_" + index,
            staticClass: "emd-breadcrumb__item",
            class: { _active: _vm.isActiveRoute(route) },
          },
          [
            _vm.lastItem(index)
              ? _c("span", { staticClass: "emd-text _color_default" }, [
                  _vm._v(_vm._s(_vm.$t(route + "." + _vm.selectedPaymentType))),
                ])
              : _vm.lastItem2(index)
              ? _c("span", { staticClass: "emd-text _color_default" }, [
                  _vm._v(
                    _vm._s(_vm.$t(route + "." + _vm.selectedPaymentType)) + " "
                  ),
                ])
              : _c(
                  "router-link",
                  {
                    staticClass: "emd-text _color_default",
                    attrs: { to: { name: "OrderType" } },
                  },
                  [_vm._v(_vm._s(_vm.$t(route)))]
                ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }